import InstreamAdSetting from '../Instream-Ad-Settings/InstreamSetting';

const CreateInstreaMSetting = () => {
    return (
        <InstreamAdSetting mode = "add" />
    )
}

export default CreateInstreaMSetting;